<template>
  <div class="mt-10">
    <div class="d-flex chzzk-home__root pt-10 pb-10">
      <!-- duplicate code -->
      <div class="d-flex flex-column align-center">
        <div style="position: relative">
          <div class="video__wrapper">
            <video id="myVideo" width="640" height="360" autoplay muted>
              <source src="/temp/showcase_1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div class="virtupet__wrapper" style="position: absolute; bottom: 0px; right: 0px">
            <div class="d-flex justify-center">
              <ModelFacade ref="modelFacade" :size="180"></ModelFacade>
            </div>
          </div>
        </div>
        <ChzzkStreamerDetail :settings="settings"></ChzzkStreamerDetail>

        <!-- VIRTUPET CONTROLLER -->
        <div class="virtupet-controller" style="width: 100%">
          <div class="virtupet-controller__background ma-6 py-4 px-4">
            <div class="d-flex justify-center align-center" style="color: white">
              <div class="pr-1">
                <img src="@/assets/login/icon.webp" width="32" height="32" />
              </div>
              <h2 style="font-size: 30px; line-height: 0px">Virtupet Controller</h2>
            </div>
            <CustomKeywordRuleRow
              class="mt-4 mb-4"
              v-for="(keywordRule, i) in keywordRules"
              :key="i"
              :index="i"
              :seedOneKeywordRule="keywordRules[i]"
              @change="onChangeKeywordRules(i, $event)"
            ></CustomKeywordRuleRow>
          </div>
        </div>
      </div>

      <div style="width: 353px" class="d-flex justify-center pos-rel">
        <div v-show="isShowInputText" class="pos-abs" style="color: white; bottom: 55px; left: -20px; z-index: 1000">
          <animated-arrow></animated-arrow>
        </div>
        <ChzzkChattingPanel ref="chzzkChattingPanel" @onUserInput="onUserInput" @on="onHandler"></ChzzkChattingPanel>
      </div>
    </div>
    <!-- 설정패널  -->
    <div class="mt-10 pa-10 setting-panel">
      <!-- <v-btn @click="onRandomInput">Random Input</v-btn> -->
      <v-btn @click="onTest">Test</v-btn>

      <div class="ml-10 mr-10">
        <h3>비디오 설정</h3>
        <v-text-field class="ml-4" v-model="settings.title" dense hide-details></v-text-field>

        <h3 class="mt-4">타이틀</h3>
        <v-text-field class="ml-4" v-model="settings.title" dense hide-details></v-text-field>

        <h3 class="mt-4">스트리머 이름</h3>
        <v-text-field class="ml-4" v-model="settings.streamerNickname" dense hide-details></v-text-field>

        <h3 class="mt-4">게임 설정</h3>
        <v-text-field class="ml-4" v-model="settings.gameTitle" dense hide-details></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import { containsKeywords } from "@/domain/server/server-logic";

import chatDatas from "../../../../components-model/chzzk/chat-datas/chat_datas_xkaue.json";
import inputStreams from "./-datas/inputStreams.json";
import delay from "@/utils/delay";
import AnimatedArrow from "./-components/AnimatedArrow.vue";
import ChzzkStreamerDetail from "./-components/ChzzkStreamerDetail.vue";
import CustomKeywordRuleRow from "./-components/CustomKeywordRuleRow.vue";

const APPEAR_INPUT_TEXT_AFTER_MS = 0;
const START_RANDOM_THREAD = true;

export default {
  components: {
    AnimatedArrow,
    ChzzkStreamerDetail,
    CustomKeywordRuleRow,
  },
  data() {
    return {
      modelIndex: "sloth",
      isShowInputText: false,
      keywordRules: [
        {
          _id: null,
          label: null,
          instructionId: "greeting-type2",
          keywords: ["펫하"],
        },
        {
          _id: null,
          label: null,
          instructionId: "action-only--legacy-happy",
          keywords: ["골", "가즈아", "펄럭", "빛흥민"],
        },
        {
          _id: null,
          label: null,
          instructionId: "action-only--legacy-angry",
          keywords: ["아오", "아니"],
        },
      ],
      settings: {
        title: "일요일 방송!",
        streamerNickname: "펫집사",
        gameTitle: "AFC 아시안 시청중",
      },
    };
  },
  methods: {
    async initModel() {
      const modelIndex = "fox_v5";
      this.$refs.modelFacade.init(modelIndex);

      return modelIndex;
    },
    onTest() {
      this.onHandler({ name: "테스트", message: "아오", isFan: true });
    },
    async showInputHereText(time_ms) {
      if (time_ms === 0) return;
      await delay(time_ms);
      this.isShowInputText = true;
    },
    onUserInput(_message) {
      const oneChat = { isFan: true, name: "테스트 사용자", color: "rgb(225, 100, 144)", message: _message };
      this.appendMessage(oneChat);
    },
    onRandomInput() {
      const oneChat = this._copied.pop();
      this.appendMessage(oneChat);
    },
    appendMessage(oneChat) {
      if (!oneChat) return;

      const keywords = [];
      this.keywordRules.forEach((keywordRule) => {
        keywords.push(...keywordRule.keywords);
      });

      // CHEATING : text -> colored text
      const message = oneChat.message;
      let modifiedMessage = message;
      // replace
      if (containsKeywords(message, this.keywordRules[0].keywords)) {
        keywords.forEach((keyword) => {
          modifiedMessage = modifiedMessage.replaceAll(
            keyword,
            `<span class="mark-1" style="color: rgb(255, 100, 100);">${keyword}</span>`,
          );
        });
      }

      if (containsKeywords(message, this.keywordRules[1].keywords)) {
        keywords.forEach((keyword) => {
          modifiedMessage = modifiedMessage.replaceAll(
            keyword,
            `<span class="mark-2" style="color: #6F9ECD;">${keyword}</span>`,
          );
        });
      }
      oneChat.modifiedMessage = modifiedMessage;

      if (this.$refs.chzzkChattingPanel) {
        this.$refs.chzzkChattingPanel.appendMessage(oneChat);
      }
    },
    onHandler(data) {
      const keywords = [];
      this.keywordRules.forEach((keywordRule) => {
        keywords.push(...keywordRule.keywords);
      });

      const { name, message, isFan } = data;

      if (containsKeywords(message, keywords)) {
        this.keywordRules.forEach((keywordRule, i) => {
          if (containsKeywords(message, keywordRule.keywords)) {
            const instructionId = keywordRule.instructionId;
            this.playAction(instructionId);
          }
        });
      }
    },
    onChangeKeywordRules(index, newKeywordRule) {
      const { _id, instructionId, keywords } = newKeywordRule;
      if (!instructionId) return;
      if (!keywords && keywords.length === 0) return;

      this.keywordRules[index].keywords = keywords;
      this.keywordRules[index].instructionId = instructionId;
    },

    playAction(instructionId) {
      this.$refs.modelFacade.executeInstruction(instructionId);
    },
    async _startRandomThread() {
      this._copied = [...chatDatas].reverse();

      const randomIntervalTimes = [600, 1000, 1500];

      for (let i = 0; i < chatDatas.length; i++) {
        const randomIntervalTime = randomIntervalTimes[Math.floor(Math.random() * randomIntervalTimes.length)];
        await delay(randomIntervalTime);

        const oneChat = this._copied.pop();
        this.appendMessage(oneChat);
      }
    },
  },
  created() {
    // init
    clearInterval(this._interval);
  },
  async mounted() {
    await this.initModel();
    this.showInputHereText(APPEAR_INPUT_TEXT_AFTER_MS);

    // Start Rand Thread
    if (START_RANDOM_THREAD) {
      this._startRandomThread();
    }

    // Chatting Input
    try {
      const streams = [...inputStreams];
      const results = [];
      for (let i = 0; i <= 30; i++) {
        const { messages } = streams.find((stream) => stream.time === i) || {};
        results.push(messages);
      }
      const messageStreams_30s = results.reverse();
      messageStreams_30s.pop();
      // make this stream to array
      this._interval = setInterval(() => {
        try {
          const messages = messageStreams_30s.pop() || [];
          messages.forEach((message) => {
            this.appendMessage(message);
          });
        } catch (error) {
          console.error(error);
        }
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  },
  destroyed() {
    clearInterval(this._interval);
  },
};
</script>

<style scoped>
.chzzk-home__root {
  background-color: #141518;
}

.setting-panel {
  background-color: rgb(205, 205, 205);
}

.virtupet-controller__background {
  border: 1px solid #9155fd;
  border-radius: 10px;
  /* background-color: #9155fd; */

  box-shadow: #9155fd 0px 5px 15px;
}
</style>
